module.exports = __webpack_public_path__ + "static/showroom.58b58b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/showroom.jpg
// module id = 129
// module chunks = 35783957827783 89518977707263